import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { deepSetObject, digObject } from '@domain-group/javascript-utils'

import { useForm } from '@domain-group/react-hooks'

import {
  Button,
  Form,
  ModalContext,
  SidebarModal,
} from '@domain-group/suit-theme'

import useServiceProduct from '@hooks/useServiceProduct'

const requiredFields = [
  { key: 'height' },
  { key: 'title' },
  { key: 'width' },
]

const defaultState = {
  height: '',
  title: '',
  width: '',
}

const createTemplatePage = (serviceProductPayload, entityState, callbacks) => {
  const { closeModal, updateServiceProduct } = callbacks || {}
  const { callbacks: { updateServiceProduct: updateFn }, serviceProduct } = serviceProductPayload

  const templatePages = digObject(serviceProduct, 'options.template.pages', [])
  templatePages.push(entityState)

  const updatedServiceProduct = deepSetObject(serviceProduct, 'options.template.pages', templatePages)

  const updateServiceProductPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: updatedServiceProduct,
    toastText: 'Template Page Created',
  }

  updateServiceProduct(updateServiceProductPayload)
}

const CreateServiceProductTemplatePageModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { serviceProduct } = digObject(modalData, modalKey, {})

  const serviceProductPayload = useServiceProduct(serviceProduct)
  const { updating } = serviceProductPayload

  const formPayload = useForm(defaultState, { requiredFields, validateOn: 'change' })

  const {
    entityState,
    entityState: { height, title, width },
    errors,
    handlers,
    saveEnabled,
  } = formPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Create"
        titleSecondLine="Template Page"
      />

      <SidebarModal.Content>
        <Form>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>

          <Form.Row marginTop="large">
            <Form.Field errorMessage={errors.width} label="* Width (mm)">
              <input name="width" value={width} type="text" {...handlers} />
            </Form.Field>

            <Form.Field errorMessage={errors.height} label="* Height (mm)" marginTop={['large', 0]}>
              <input name="height" value={height} type="text" {...handlers} />
            </Form.Field>
          </Form.Row>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          onClick={() => createTemplatePage(serviceProductPayload, entityState, callbacks)}
          size="large"
        >
          {saveEnabled ? 'Create Template Page' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateServiceProductTemplatePageModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

CreateServiceProductTemplatePageModal.defaultProps = {
  modalKey: 'CreateServiceProductTemplatePageModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateServiceProductTemplatePageModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
